import React from "react"
import { useHistory } from "react-router-dom"
import { useTranslation, Trans } from "react-i18next"

function BannerHome() {
  const history = useHistory()
  const { t } = useTranslation()
  const handleToAboutUs = () => {
    history.push("/aboutus")
  }
  return (
    <div className="uk-padding uk-padding-remove-top uk-flex-1 uk-flex uk-flex-middle uk-flex-center">
      <div className="uk-text-center">
        <div className="slogan-heading">
          <Trans
            i18nKey="home.jumbotronTitle"
            components={{ red: <span className="font-red" /> }}
          />
        </div>
        <div
          className="uk-text-light uk-margin-bottom font-white"
          style={{ fontSize: 20 }}
        >
          {t("home.jumbotronDesc")}
        </div>
        <button
          onClick={handleToAboutUs}
          className="uk-button uk-button-default font-white"
        >
          {t("home.jumbotronAbout")}
        </button>
      </div>
    </div>
  )
}

export default BannerHome
